export const utilConstants = {
    /* DEBUG */
    /* serverBaseURL: "http://localhost:4567/", */
    /* DEBUG */
    /* serverBaseURL: "http://192.168.1.143:3301/" ,*/
    /* PRODUCTION */
    serverBaseURL: "https://appsempredicorsa.it/",
    version: "v1.0.4",
}